<template>
  <b-tooltip
    v-if="show"
    class="app-button-add-ciec"
    type="is-eucalyptus"
    :label="message"
    multilined
    always
  >
    <router-link :to="to">
      <b-button
        size="is-medium"
        type="is-eucalyptus"
        icon-left="archive"
      />
    </router-link>
  </b-tooltip>
</template>

<script>
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('company');

const message = '¡Haz click aquí para sincronizar tus facturas con el SAT!';

export default {
  name: 'AppButtonAddCIEC',
  data() { return { message }; },
  computed: merge(
    mapState({
      ciec: ({ ciec }) => ciec,
      id: ({ id }) => id,
    }),
    {
      show() {
        const { ciec } = this;
        const { name } = this.$route;

        return !ciec && name !== 'AddCIEC';
      },
      to() {
        const { id } = this;

        return {
          name: 'AddCIEC',
          params: { id },
        };
      },
    },
  ),
};
</script>

<style>
.app-button-add-ciec {
  margin-bottom: 1rem;
}
</style>
